var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7.83333V10.2778C11.5 10.6019 11.3712 10.9128 11.142 11.142C10.9128 11.3712 10.6019 11.5 10.2778 11.5H1.72222C1.39807 11.5 1.08719 11.3712 0.857981 11.142C0.628769 10.9128 0.5 10.6019 0.5 10.2778V7.83333M2.94444 4.77778L6 7.83333M6 7.83333L9.05556 4.77778M6 7.83333V0.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.a41c325086c074f1b511714cb1fa0e4b.svg";
export { ForwardRef as ReactComponent };